<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const ChatIconComment = getIcon("ChatIconComment");
</script>

{#if typeof ChatIconComment === 'string'}
	<img src={ChatIconComment} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof ChatIconComment === 'function'}
	<svelte:component this={ChatIconComment} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
